import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>HeroPixelLab - Premium Online Dataspill</title>
        <meta name="description" content="HeroPixelLab - premium nettbutikk for online dataspill. Oppdag eksklusive spill, digitale nøkler og unike samleobjekter." />
        <link href="https://heropixellab.com/refund-policy/" rel="canonical"/>
      </Helmet>

      <div className="refund-policy">
      <h1>Refusjonspolitikk</h1>
      <p className="last-updated">Sist oppdatert: 1. januar 2025</p>

      <section>
        <h2>1. Generelt</h2>
        <p>
          Vi ønsker at du skal være fornøyd med kjøpet ditt. Denne refusjonspolitikken beskriver dine rettigheter og muligheter for refusjon ved kjøp fra HeroPixelLab. Vi gjør vårt beste for å håndtere alle forespørsler raskt og rettferdig.
        </p>
      </section>

      <section>
        <h2>2. Angrerett for forbrukere</h2>
        <p>
          I henhold til angrerettloven har du som forbruker rett til å angre kjøpet ditt innen 14 dager. Vær oppmerksom på at angreretten har særlige regler for digitale produkter.
        </p>

        <h3>2.1 Digitale produkter</h3>
        <ul>
          <li><strong>Angreretten bortfaller</strong> når leveringen av det digitale innholdet har begynt</li>
          <li>Når spillnøkkelen er sendt til deg, anses leveringen som startet</li>
          <li>Du har <strong>ikke</strong> angrerett på digitale produkter som er levert</li>
          <li>Dette gjelder også for produkter som er aktivert eller brukt</li>
        </ul>

        <h3>2.2 Fysiske produkter</h3>
        <ul>
          <li>14 dagers angrefrist fra mottak av varen</li>
          <li>Varen må returneres i ubrukt stand med original emballasje</li>
          <li>Retur fraktkostnader dekkes av kunden (inntil kr 300)</li>
          <li>Refusjon utbetales innen 14 dager etter mottak av retur</li>
        </ul>
      </section>

      <section>
        <h2>3. Refusjon ved tekniske feil</h2>
        <h3>3.1 Defekte spillnøkler</h3>
        <ul>
          <li>Hvis mottatt spillnøkkel ikke fungerer, har du krav på refusjon eller erstatning</li>
          <li>Kravet må fremsettes innen 30 dager etter kjøp</li>
          <li>Du må kunne dokumentere feilen (f.eks. skjermbilde av feilmelding)</li>
          <li>Vi tilbyr først ny nøkkel, hvis det ikke finnes, refunderes kjøpet</li>
        </ul>

        <h3>3.2 Feil produkt levert</h3>
        <ul>
          <li>Ved feil produkt levert, rettes feilen uten ekstra kostnad</li>
          <li>Hvis feilen ikke kan rettes, refunderes fullt beløp</li>
          <li>Vi dekker eventuelle ekstra utlegg kunden måtte ha</li>
        </ul>

        <h3>3.3 Manglende levering</h3>
        <ul>
          <li>Hvis produktet ikke leveres innen annonsert tid, har du krav på refusjon</li>
          <li>For digitale produkter: refusjon hvis ikke levert innen 72 timer</li>
          <li>For fysiske produkter: refusjon hvis ikke levert innen 30 dager</li>
        </ul>
      </section>

      <section>
        <h2>4. Refusjonsprosess</h2>
        <h3>4.1 Slik søker du om refusjon</h3>
        <ol>
          <li>Kontakt vår kundeservice på heropixellab@hotmail.com</li>
          <li>Oppgi ordrenummer og beskriv problemet</li>
          <li>Ved tekniske feil: legg ved dokumentasjon</li>
          <li>Ved fysiske produkter: motta returetikett for frakt</li>
        </ol>

        <h3>4.2 Behandlingstid</h3>
        <ul>
          <li>Vi bekrefter mottatt forespørsel innen 24 timer</li>
          <li>Refusjonssøknader behandles innen 5 virkedager</li>
          <li>Eventuell refusjon utbetales innen 14 dager etter godkjenning</li>
          <li>VED KORTBETALING: Refusjonen går til kortet som ble brukt</li>
          <li>VED VIPPS: Refusjonen går til Vipps-registrert konto</li>
          <li>VED KLAANA: Refusjon behandles i henhold til Klarnas retningslinjer</li>
        </ul>
      </section>

      <section>
        <h2>5. Refusjonsbeløp</h2>
        <h3>5.1 Full refusjon gis når:</h3>
        <ul>
          <li>Kjøpet er basert på feil beskrivelse fra vår side</li>
          <li>Produktet er defekt eller ikke fungerer</li>
          <li>Produktet ikke er levert innen avtalt frist</li>
          <li>Kunden benytter lovfestet angrerett for fysiske produkter</li>
        </ul>

        <h3>5.2 Ingen refusjon gis når:</h3>
        <ul>
          <li>Digitale nøkler er levert og fungerer</li>
          <li>Direkte nedlasting er påbegynt (unntatt ved tekniske feil)</li>
          <li>Kunden har forsøkt å videreselge eller dele produktet</li>
          <li>Tidsfristen for reklamasjon er overskredet</li>
          <li>Spillkontoen har blitt brukt og senere angrer</li>
        </ul>

        <h3>5.3 Delvis refusjon</h3>
        <ul>
          <li>Hvis produktet er brukt og returnert, kan vi tilby delvis refusjon</li>
          <li>Ved tapt verdi eller redusert produktverdi</li>
          <li>Vurderes fra sak til sak</li>
        </ul>
      </section>

      <section>
        <h2>6. Spesielle tilfeller</h2>
        <h3>6.1 Kjøp i kampanjer og salg</h3>
        <ul>
          <li>Kampanjeprodukter følger samme refusjonsregler som øvrige produkter</li>
          <li>Ved refusjon refunderes faktisk betalt beløp</li>
        </ul>

        <h3>6.2 Gaver og gavekort</h3>
        <ul>
          <li>Gavekort refunderes ikke kontant</li>
          <li>Gavekort kan brukes til andre kjøp</li>
          <li>Kjøp med gavekort refunderes til nytt gavekort</li>
        </ul>

        <h3>6.3 Pakkeprodukter (bundles)</h3>
        <ul>
          <li>Refusjon for individuelle produkter i pakker kan variere</li>
          <li>Pakken kan refunderes i sin helhet eller delvis per vareslag</li>
          <li>Vurderes i henhold til forbrukerkjøpsloven</li>
        </ul>

        <h3>6.4 Pre-orders og forhåndsbestillinger</h3>
        <ul>
          <li>Pre-orders refunderes fullt ut før lanseringsdato</li>
          <li>Etter levering gjelder standard refusjonsregler</li>
          <li>Spesielle betingelser kan gjelde ved forsinkelser</li>
        </ul>
      </section>

      <section>
        <h2>7. Reklamasjon og garantier</h2>
        <h3>7.1 Reklamasjonsfrister</h3>
        <ul>
          <li><strong>Digitale produkter:</strong> 1 år fra kjøpsdato</li>
          <li><strong>Fysiske produkter:</strong> 2 år fra mottak (forbrukerkjøpsloven)</li>
          <li>Reklamasjon må fremsettes innen rimelig tid etter at mangelen er oppdaget</li>
        </ul>

        <h3>7.2 Kravets innhold</h3>
        <ul>
          <li>Reklamasjonen skal inneholde ordrenummer</li>
          <li>Beskrivelse av mangelen</li>
          <li>Krav om retting, omlevering, prisavslag eller heving</li>
        </ul>
      </section>

      <section>
        <h2>8. Betalingstjenester og refusjon</h2>
        <h3>8.1 Kortbetaling</h3>
        <ul>
          <li>Refusjon går til kortet som ble brukt ved kjøpet</li>
          <li>Behandlingstid: 5-14 virkedager avhengig av bank</li>
        </ul>

        <h3>8.2 Vipps</h3>
        <ul>
          <li>Refusjon sendes tilbaketil Vipps-konto</li>
          <li>Behandlingstid: 3-5 hverdager</li>
        </ul>

        <h3>8.3 Klarna</h3>
        <ul>
          <li>Refusjon behandles i henhold til Klarnas betingelser</li>
          <li>Faktura slettes og justering skjer via Klarna-app</li>
        </ul>

        <h3>8.4 PayPal</h3>
        <ul>
          <li>Refusjon går tilbake til PayPal-kontoen</li>
          <li>Behandlingstid: 1-5 virkedager</li>
        </ul>
      </section>

      <section>
        <h2>9. Kontakt</h2>
        <p>
          Har du spørsmål om refusjonspolitikken?
        </p>
        <ul>
          <li>E-post: heropixellab@hotmail.com</li>
          <li>Telefon: +4738172040</li>
          <li>Chat: via vår nettside (hverdager 09:00–16:00)</li>
        </ul>
      </section>

      <section>
        <h2>10. Tvisteløsning</h2>
        <p>
          Hvis vi ikke klarer å finne en løsning, kan du:
        </p>
        <ul>
          <li>Klage til Forbrukertilsynet</li>
          <li>Bruke EU-kommisjonens ODR-plattform</li>
          <li>Bringe saken inn for Forbrukertvistutvalget</li>
        </ul>
        <p>
          Alle forespørsler behandles i henhold til norsk forbrukerlovgivning og EUs forbrukerdirektiver.
        </p>
      </section>

      <section>
        <h2>11. Informasjonskrav</h2>
        <p>
          I henhold til angrerettloven er du som forbruker informert om din rett til å angre kjøpet. Fullstendig informasjon finnes i angrerettskjemaet som følger med din ordrebekreftelse for fysiske produkter. For digitale produkter får du informasjon tilsendt før du fullfører kjøpet.
        </p>
      </section>

      <p className="policy-footer">© 2025 HeroPixelLab. Alle rettigheter forbeholdt.</p>
    </div>
  
    </>);
};

export default RefundPolicy;